<template>
  <v-footer
    tile
    color="transparent"
    class="progress-indicator"
    v-if="user && user.emailVerified && isNotAdmin && currentCourse.length > 0"
  >
    <div class="course-sections" :class="currentCourse[0].baseYear">
      <!-- the :key used to be section.title -->
      <div
        v-for="(section, index) in currentCourse[0].sections"
        :key="index"
        :class="convertToClass(section.title)"
        :style="{ width: calcUnitWidth(currentCourse[0].sections) + '%' }"
      >
        <div class="course-section-container">
          <div class="course-section">
            <span
              v-for="(grandchild, index) in section.units"
              :key="index"
              :style="{ width: calcUnitWidth(section.units) + '%' }"
              class="section-unit"
              :class="{
                active:
                  activeUnit == grandchild.id ||
                  grandchild.status == 'archived',
              }"
              :id="grandchild.id"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </v-footer>
</template>

<script>
  import firebase from 'firebase'
  import axios from 'axios'
  import db from '@/firebase/init'
  import { scopeToChurch } from '@/helpers/churchScope'
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        sectionWidth: 0,
        unitWidth: 0,
        currentCourse: [],
        courseContent: [],
        unitActive: true,
      }
    },
    watch: {
      '$route.params.id': {
        handler: function (search) {
          if (search) this.init()
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      isNotAdmin() {
        return (
          this.$route.path === '/' ||
          // this.$route.name === 'Home' ||
          // this.$route.name === 'Login' ||
          // this.$route.name === 'Welcome' ||
          this.$route.name === 'Unit'
        )
      },
      convertToClass() {
        return (str) => {
          if (str) {
            const ele = str.toLowerCase().replace(/ /g, '-')
            return ele
          }
          return false
        }
      },
      activeUnit: {
        get() {
          return this.$store.getters['AppData/activeUnit']
        },
        set(value) {
          console.log(value)
          this.$store.dispatch('AppData/setActiveUnit', value)
        },
      },
      ...mapState('UserData', ['user', 'profileComplete']),
      ...mapState('AppData', ['courseDrawer', 'userActiveCourse']),
      ...mapGetters('AppData', [
        'getChurchById',
        'getCourse',
        'getSections',
        'getUnits',
        'cid',
      ]),
    },
    methods: {
      calcUnitWidth(num) {
        // console.log(num.length)
        if (num.length > 0)
          // Math.round(100/num.length)
          return 100 / num.length

        return false
      },
      async init() {
        this.currentCourse = []
        this.courseContent = []

        // let unitID = this.$route.params.id
        let courseID = this.$route.params.courseID
        // let sectionID = this.$route.params.sectionID

        let currentCourseRef = db.collection('currentcourses')
        currentCourseRef = currentCourseRef.where('storageID', '==', courseID)
        currentCourseRef = scopeToChurch(currentCourseRef, this.$store)
        let activeRef = await currentCourseRef.get()

        if (!activeRef.empty) {
          const doc = activeRef.docs[0]
          let course = doc.data()
          course.id = doc.id

          const storage = firebase.storage()
          const storageRef = storage.ref()
          const objectRef = storageRef.child(course.storageRef)
          let url = await objectRef.getDownloadURL()
          let resp = await axios.get(url)

          const missionRef = firebase.storage().ref().child(course.missions)
          let missionURL = await missionRef.getDownloadURL()
          let missionResp = await axios.get(missionURL)

          resp.data.missions = missionResp.data

          // look in the currentcourse collection for all isUnitStatus's
          let coursecontentRef = db.collection('coursecontent')
          coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
          coursecontentRef = coursecontentRef.where('isUnitStatus', '==', 'yes')
          let activeCourseContentRef = await coursecontentRef.get()
          for (const doc of activeCourseContentRef.docs) {
            this.courseContent.push(doc.data())
          }

          // if the unit has been archived (completed) set it to archived
          resp.data.sections.filter((item) => {
            item.units.filter((u) => {
              const foundUnit = this.courseContent.find((c) => c.unitID == u.id)
              if (foundUnit)
                u.status = foundUnit.unitActive
                  ? foundUnit.unitActive
                  : 'archived'
            })
          })

          this.currentCourse.push(resp.data)
          // console.log(this.currentCourse)
        }
      },
    },
  }
</script>

<style scoped>
  .course-section-container {
    display: flex;
    height: 40px;
    align-items: center;
  }
  .course-sections {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex: 1;
  }
  .course-section {
    display: flex;
    margin: 0 10px;
    height: 4px;
    border: 1px solid #a5d866;
    flex: 1;
  }
  footer.v-footer {
    flex: 0 1 auto;
  }
  footer.v-footer.progress-indicator:after {
    content: '';
    position: absolute;
    top: -18px;
    left: 0;
    width: 100%;
    background: #fff;
    height: 70px;
    filter: blur(20px);
    z-index: -1;
  }
  footer.v-theme--dark.v-footer.progress-indicator:after {
    background: #000;
  }
  .blueYear .course-section {
    border: 1px solid #002b45;
  }
  .v-theme--dark .blueYear .course-section {
    border: 1px solid #5b6d81;
  }
  .greenYear .course-section {
    border: 1px solid #024731;
  }
  .v-theme--dark .greenYear .course-section {
    border: 1px solid #5e8372;
  }
  .redYear .course-section {
    border: 1px solid #6e273d;
  }
  .v-theme--dark .redYear .course-section {
    border: 1px solid #a26f7b;
  }
  .section-unit.active,
  .section-unit.complete {
    background: #a5d866;
  }
  .blueYear .section-unit.active,
  .blueYear .section-unit.complete {
    background: #002b45;
  }
  .v-theme--dark .blueYear .section-unit.active,
  .v-theme--dark .blueYear .section-unit.complete {
    background: #5b6d81;
  }
  .greenYear .section-unit.active,
  .greenYear .section-unit.complete {
    background: #024731;
  }
  .v-theme--dark .greenYear .section-unit.active,
  .v-theme--dark .greenYear .section-unit.complete {
    background: #5e8372;
  }
  .redYear .section-unit.active,
  .redYear .section-unit.complete {
    background: #6e273d;
  }
  .v-theme--dark .redYear .section-unit.active,
  .v-theme--dark .redYear .section-unit.complete {
    background: #a26f7b;
  }
  .v-tooltip__content {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.87);
    background: transparent;
    padding-bottom: 0;
  }
  .section-number {
    font-size: 22px;
  }
  .unit-title {
    font-size: 12px;
  }
  .unit-title.active {
    font-weight: 900;
  }
  .blueYear {
    color: #002b45;
  }
  .v-theme--dark .blueYear {
    color: #5b6d81;
  }
  .greenYear {
    color: #024731;
  }
  .v-theme--dark .greenYear {
    color: #5e8372;
  }
  .redYear {
    color: #6e273d;
  }
  .v-theme--dark .redYear {
    color: #a26f7b;
  }
  @media only screen and (max-width: 767px) {
    footer.v-footer.progress-indicator:after {
      top: 0;
    }
    .v-tooltip__content {
      background: #fff;
    }
  }
</style>
